import React, { ReactNode } from "react";

import Dialog from "veneer/Dialog";

interface ConfirmModalProps {
  children?: ReactNode;
  commitDisabled?: boolean;
  commitLabel: string;
  onClose: () => void;
  onCommit: () => void;
  open: boolean;
}

export default function ConfirmModal({
  children,
  commitDisabled,
  commitLabel,
  onClose,
  onCommit,
  open,
}: ConfirmModalProps) {
  if (!open) return null;
  return (
    <Dialog
      commitDisabled={commitDisabled}
      commitLabel={commitLabel}
      onCancel={onClose}
      onCommit={onCommit}
      onDismiss={onClose}
      open
      title="Are you sure?"
      variant="modal"
    >
      {children}
    </Dialog>
  );
}
